import React, { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

import Button from 'components/Shared/Button/Button';
import { Lock } from 'components/Shared/Icons/Icons';
import { colors } from 'styles/cp';

interface SignInButtonProps {
  onClick: () => void;
  messageId?: string;
  defaultMessage?: string;
  className?: string;
  children?: ReactNode;
}

const SignInButton: React.FC<SignInButtonProps> = ({
  onClick,
  messageId = 'SIGN_OR_ACCOUNT',
  defaultMessage = 'Sign in or create account',
  className,
  children,
}) => {
  return (
    <Button onClick={onClick} buttonType="primary" size="jumbo" width="100%" className={className}>
      <span className="sign-in-content">
        <Lock color={colors.white} strokeWidth={2} height={15} width={12} className="lock-icon" />
        {children || <FormattedMessage id={messageId} defaultMessage={defaultMessage} />}
      </span>
      <style jsx>{`
        .sign-in-content {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
        }
      `}</style>
    </Button>
  );
};

export default SignInButton;
